export const DECISION_MAKER_HASH_QUERY_PARAM_NAME = 'response';
